import React, { useContext } from 'react';
import LanguageContext from '../contexts/LanguageContext';
import ReactFlagsSelect from 'react-flags-select';

const Header = () => {
  const { language, setLanguage } = useContext(LanguageContext);

  const handleLanguageChange = (code) => {
    if (code === 'GB') {
      setLanguage('en');
    } else if (code === 'PL') {
      setLanguage('pl');
    }
  };

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 md:h-20">
          <div className="text-2xl md:text-3xl font-bold text-red-500">
            AI Kitchen Chef
          </div>
          <div className="flex items-center">
            <ReactFlagsSelect
              selected={language === 'en' ? 'GB' : 'PL'}
              onSelect={handleLanguageChange}
              countries={['GB', 'PL']}
              customLabels={{ GB: 'English', PL: 'Polski' }}
              showOptionLabel={true}
              showSelectedLabel={true}
              placeholder="Select Language"
              className="flag-select"
            />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
